module.exports = {
  HOME_PATH: 'src/pages/home.js',
  CAREERS_ROUTE: 'carreras',
  DIARIES_ROUTE: 'agenda',
  NEWS_ROUTE: 'noticias',
  NOTES_ROUTE: 'notas',
  CAREER_TEMPLATE_PATH: `src/templates/Career/career.js`,
  DIARY_TEMPLATE_PATH: `src/templates/Diary/diary.js`,
  MICROSITE_TEMPLATE_PATH: `src/templates/Microsite/microsite.js`,
  NOVELTY_TEMPLATE_PATH: `src/templates/Novelty/novelty.js`,
  PAGE_TEMPLATE_PATH: `src/templates/Page/page.js`,
  FEED_DIARIES_ALL_TEMPLATE_PATH: 'src/templates/DiariesFeed/allDiariesFeed.js',
  FEED_NEWS_ALL_TEMPLATE_PATH: 'src/templates/NewsFeed/allNewsFeed.js',
  FEED_NOTES_ALL_TEMPLATE_PATH: 'src/templates/NotesFeed/allNotesFeed.js',
  FEED_CAREERS_ROUTE: 'propuesta-academica',
  FEED_CAREERS_TEMPLATE_PATH: `src/templates/CareerFeed/careerFeed.js`,
  FEED_CAREERS_CS_SALUD_ROUTE: 'propuesta-academica/especialidades-medicas',
  FEED_CAREERS_CS_SALUD_TEMPLATE_PATH: `src/templates/CareerFeedCsSalud/careerFeedCsSalud.js`,
  

  // FEED_DIARIES_BY_CATEGORY_PATH: 'src/templates/diariesFeeds/diaries-byCategory.js',
  // FEED_DIARIES_OU_ALL_PATH: 'src/templates/diariesFeeds/diaries-ou-all.js',
  // FEED_DIARIES_OU_BY_CATEGORY_PATH: 'src/templates/diariesFeeds/diaries-ou-byCategory.js',
  // FEED_NEWS_OU_ALL_PATH: 'src/templates/newsFeeds/news-ou-all.js',
  // FEED_NEWS_OU_BY_CATEGORY_PATH: 'src/templates/newsFeeds/news-ou-byCategories.js',
  // FEED_NEWS_BY_CATEGORY_PATH: 'src/templates/newsFeeds/news-byCategory.js',
  
  // NOTES_ROUTE: 'notas',
  // FEED_NOTES_ALL_PATH: 'src/templates/notesFeeds/notes-all.js',
  // NOTE_PAGE_PATH: 'src/templates/note-page.js',
  // LANDING_ROUTE: 'landing',
  // LANDING_PATH: 'src/templates/landingPages/landing-page.js',
}
